/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICustomerAutocompleteSuggestion } from './APICustomerAutocompleteSuggestion';
import {
    APICustomerAutocompleteSuggestionFromJSON,
    APICustomerAutocompleteSuggestionFromJSONTyped,
    APICustomerAutocompleteSuggestionToJSON,
} from './APICustomerAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APICustomerAutocompleteResponse
 */
export interface APICustomerAutocompleteResponse {
    /**
     * 
     * @type {Array<APICustomerAutocompleteSuggestion>}
     * @memberof APICustomerAutocompleteResponse
     */
    suggestions: Array<APICustomerAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APICustomerAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APICustomerAutocompleteResponse interface.
 */
export function instanceOfAPICustomerAutocompleteResponse(value: object): value is APICustomerAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APICustomerAutocompleteResponseFromJSON(json: any): APICustomerAutocompleteResponse {
    return APICustomerAutocompleteResponseFromJSONTyped(json, false);
}

export function APICustomerAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APICustomerAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APICustomerAutocompleteResponseToJSON(value?: APICustomerAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APICustomerAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

